/* Copyright (c) 2020-present CloudIO Inc */

import { gridSize } from 'componentregistry/registry/constants';
import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue } from './NumberSearchField';

const NumberSearchFieldManager: ComponentManagerFn<'NumberSearchField'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'NumberSearchField'>(platform, 'NumberSearchField'),
    type: 'NumberSearchField',
    name: 'Number Search Field',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnClick'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      label: {
        label: 'Label',
        type: 'string',
      },
      helperText: {
        label: 'Helper Text',
        type: 'string',
      },
      viewAttribute: {
        label: 'View Attribute',
        type: 'ViewAttributeChooser',
        aliasType: 'STORE',
        getAttributeDataTypes: () => ['Integer', 'Decimal', 'Double'],
        preventMultiEdit: true,
      },
      allowDecimal: {
        label: 'Allow Negative',
        type: 'boolean',
      },
      allowNegative: {
        label: 'Allow Negative',
        type: 'boolean',
      },
      flex: {
        label: 'Flex',
        type: 'grid',
        options: gridSize,
        required: true,
        helpText:
          'Defines the number of grids the component is going to use on an extra large screen.',
        category: 'Layout',
      },
    },
    generateShortId: (item) => item.label,
    category: 'Search',
    icon: { iconName: 'search' },
    deprecated: 'Use Search Number Field instead.',
    replaceableWith: ['SearchNumberField'],
    description: `Use this search field to perform the search on number columns. Use can perform search operations like an exact match, between and lesser/greater than...
    \n ## Examples: \n
    Search exact match: 500 \n 
    Search between two numbers : 500-1000 \n 
    Search less then number: <500 \n 
    Search greater then number: >500`,
  };
};

export default NumberSearchFieldManager;
